import Avatar from 'components/Avatar'
import BrowseDefaultIcon from 'components/icons/BrowseDefaultIcon'
import RightArrow from 'components/icons/RightArrow'
import { SecondGreyText, SubFLex } from '../style'
import React from 'react'

const SocialMediaLinks = ({ studentDetails }) => {
  return (
    
      <SubFLex column gap="20px">
        {studentDetails?.studentPersonalProfile?.socialMedia?.map(
          (item, index) => (
            <SubFLex centerVertically gap="10px" key={index+"socialMedia"}>
              <div>
                <Avatar
                  src={''}
                  size={24}
                  icon={<BrowseDefaultIcon />}
                  background="none"
                />
              </div>
              <SecondGreyText marginBottom="0">
                <a
                  style={{ color: '#A3ADB8' }}
                  href={item?.link}
                  target="blank"
                >
                  {item?.link}
                </a>
              </SecondGreyText>
              <RightArrow />
            </SubFLex>
          )
        )}
      </SubFLex>
    
  )
}

export default SocialMediaLinks
